import { render, staticRenderFns } from "./ExportComponents.vue?vue&type=template&id=5bf70d61&scoped=true"
import script from "./ExportComponents.vue?vue&type=script&lang=js"
export * from "./ExportComponents.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bf70d61",
  null
  
)

export default component.exports